import { getCurrentInstance } from 'vue'
import type { VueGtag } from 'vue-gtag'

const useGtag = (): VueGtag => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return getCurrentInstance()!.proxy.$gtag
}

export {
    useGtag
}
